import PropTypes from "prop-types";

export const AssetTypeAttributes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
};

export const AssetTypeType = PropTypes.shape(AssetTypeAttributes);
